module.exports = __webpack_public_path__ + "img/new-logo.db9f442.png";